
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as sse99jgEnCdp9Ex0vmmsVsNaO9qZto7y_45E3hia_45AROg9MUMeta } from "/opt/buildhome/repo/src/nuxt/pages/sse.vue?macro=true";
import { default as logout_45m5e7j_OYw6_45POwq6ZniLZKo_45BJ1T4T_qTiPOTdW4A8Meta } from "/opt/buildhome/repo/src/nuxt/pages/logout.vue?macro=true";
import { default as _91_46_46_46slug_935emrVJNK9Drp9RoVbbV6dBQe6_lPwAkp_45rnQrvI5XqkMeta } from "/opt/buildhome/repo/src/nuxt/pages/[...slug].vue?macro=true";
import { default as braindateAxhYFLxtmvDR0a9Spe8P9I8kmsxWCNvUuxgr4r5IRSEMeta } from "/opt/buildhome/repo/src/nuxt/pages/braindate.vue?macro=true";
import { default as _91id_93ZcMlaKCazhohd1aT3XL_45gb5IzcHotXsMOoOcEMOKi9kMeta } from "/opt/buildhome/repo/src/nuxt/pages/sessions/[id].vue?macro=true";
import { default as _91id_93uB_45Q66gYVHUGz9gB7_45U2igtDfuuuE3RCTCruxXjd1LQMeta } from "/opt/buildhome/repo/src/nuxt/pages/speakers/[id].vue?macro=true";
import { default as _91id_93Md0HB48juv8EX_45fOtV3MNjBTyc9gGVvcVzWyolVXQ7sMeta } from "/opt/buildhome/repo/src/nuxt/pages/favorites/[id].vue?macro=true";
import { default as test_45assistantAYw8XLaea_oOC7Gfyh1ACqFxSLiljw_fY8WvUi_YDP4Meta } from "/opt/buildhome/repo/src/nuxt/pages/test-assistant.vue?macro=true";
import { default as reserveCG4dVRqop_45wsIfovwslNLO2DBk9EVrWyf0GSKV0vMtUMeta } from "/opt/buildhome/repo/src/nuxt/pages/sessions/reserve.vue?macro=true";
import { default as _91id_93Gh3hxLha1kFCXUEpfxFdpRAB_n24HQjRHIPFvv_V98AMeta } from "/opt/buildhome/repo/src/nuxt/pages/reservations/[id].vue?macro=true";
import { default as assistant_45comparisonsZAqRIvnx6mEbsGPEPVPBPVytE2G_45TKoXKKoEkvdYbEMeta } from "/opt/buildhome/repo/src/nuxt/pages/assistant-comparison.vue?macro=true";
import { default as component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRIMeta } from "/opt/buildhome/repo/src/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRI } from "/opt/buildhome/repo/src/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "sse",
    path: "/sse",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/sse.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/logout.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/[...slug].vue")
  },
  {
    name: "braindate",
    path: "/braindate",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/braindate.vue")
  },
  {
    name: "sessions-id",
    path: "/sessions/:id()",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/sessions/[id].vue")
  },
  {
    name: "speakers-id",
    path: "/speakers/:id()",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/speakers/[id].vue")
  },
  {
    name: "favorites-id",
    path: "/favorites/:id()",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/favorites/[id].vue")
  },
  {
    name: "test-assistant",
    path: "/test-assistant",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/test-assistant.vue")
  },
  {
    name: "sessions-reserve",
    path: "/sessions/reserve",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/sessions/reserve.vue")
  },
  {
    name: "reservations-id",
    path: "/reservations/:id()",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/reservations/[id].vue")
  },
  {
    name: "assistant-comparison",
    path: "/assistant-comparison",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/assistant-comparison.vue")
  },
  {
    name: component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRI
  }
]